import React, { Component } from 'react'
import { DragDropContext } from 'react-beautiful-dnd';
import Column from './Column';
import { connect } from 'react-redux';
import { Dispatch, AnyAction, bindActionCreators } from 'redux';
import { getProductReturns, dragAndDrop, getProductTypes, updateProductReturnById } from '../../store/actions/mainDashboard';
import { get } from 'lodash';
import { IColumn, IUpdateResponse, UpdateType, ActionType } from '../../shared/models/mainDashboardModel';
import { IUser } from '../../shared/models/adminModels';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import instance from '../../services/requestService';
import './mainDashboard.css';
import * as signalR from '@aspnet/signalr';

interface IProps {
    productReturns: IColumn[];
    user: IUser;
    autoUpdate: boolean;
    getProductTypes: Function;
    getProductReturns: Function;
    dragAndDrop: Function;
    updateProductReturnById: Function;
}

interface IState {
    hubConnection?: HubConnection;
}

class MainDashboard extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    componentDidMount() {
        const { permission } = this.props.user
        const canCreate = get(permission.productReturnDashboard, 'create', false);
        canCreate && this.props.getProductTypes();
        this.props.getProductReturns();
        let hubConnection = new HubConnectionBuilder()
            .withUrl(instance.defaults.baseURL + "/dashbordHub",
                signalR.HttpTransportType.WebSockets
            )
            .build();
        this.setState({ hubConnection }, () => {
            this.startConnection();
            this.receiveSignals();
            this.state.hubConnection?.onclose(() => {
    console.warn("⚠ SignalR Disconnected");
});
            
        });

        document.body.classList.add('main-dashboard');
    }

    componentWillUnmount() {
        this.state?.hubConnection?.stop();
        document.body.classList.remove('main-dashboard');
    }

    startConnection = () => {
    this.state.hubConnection?.start()
        .then(() => {
            console.log("✅ SignalR Connected");
        })
        .catch((err: any) => {
            console.error("❌ SignalR Connection Error", err);
        });
}

    receiveSignals = () => {
        const { autoUpdate, getProductReturns, updateProductReturnById } = this.props;
        this.state.hubConnection?.on('updateDashbord', (res: IUpdateResponse) => {
    console.log("🔥 SIGNAL RECEIVED", res);

    const { autoUpdate, getProductReturns, updateProductReturnById } = this.props;

    if (res.data?.actionType === ActionType.timeElapsedUpdate && res.data?.updateType === UpdateType.fulldashboard) {
        console.log("➡ Full dashboard update triggered (timeElapsed)");
        autoUpdate && getProductReturns();
        return;
    }

    if (res.data?.updateType === UpdateType.fulldashboard) {
        console.log("➡ Full dashboard refresh");
        autoUpdate && getProductReturns();
    } else if (res.data?.updateType === UpdateType.itemUpdate) {
        console.log("➡ Single item update", res.data.itemId);
        autoUpdate && updateProductReturnById(res.data.itemId)
    }
});
    }

    onDragEnd = (result: any) => {
        this.props.dragAndDrop(result);
    }

    render() {
        console.log("🎨 Rendering dashboard", this.props.productReturns);
        const { permission } = this.props.user
        return (
            // <div className="container-fluid">
            // <div className="page-content">
            <div className="layout layout-nav-side">
                <div className="main-container">
                    <div className="container-kanban">
                        <div className="kanban-board container-fluid mt-lg-3">
                            {/* <ul className="kanban-wrp"> */}
                            <DragDropContext
                                onDragEnd={this.onDragEnd}>
                                {this.props.productReturns.map((column: any) => (
                                    <Column
                                        key={column.id}
                                        canAdd={get(permission.productReturnDashboard, 'create', false)}
                                        canEdit={get(permission.productReturnDashboard, 'edit', false)}
                                        canView={get(permission.productReturnDashboard, 'view', false)}
                                        column={column}
                                    />
                                ))}
                            </DragDropContext>
                            {/* </ul> */}
                        </div>
                    </div>
                </div>
            </div>
            // </div>
            // </div>
        )
    }
}

const mapStateToProps = (state: any) => ({
    autoUpdate: state.mainDashboard.autoUpdate,
    productReturns: state.mainDashboard.productReturns,
    user: state.auth.user
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    getProductTypes: bindActionCreators(getProductTypes, dispatch),
    getProductReturns: bindActionCreators(getProductReturns, dispatch),
    dragAndDrop: bindActionCreators(dragAndDrop, dispatch),
    updateProductReturnById: bindActionCreators(updateProductReturnById, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MainDashboard)